<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="120px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="升级前产品编码">
            <el-input v-model="searchForm.productCodeBefore" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="升级前产品名称">
            <el-input v-model.trim="searchForm.productNameBefore" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="升级后产品编码">
            <el-input v-model="searchForm.productCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="升级后产品名称">
            <el-input v-model.trim="searchForm.productName" @keyup.enter.native="onSearch" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="synchronous(false)">同步</el-button>
        <el-button class="orange-btn" size="mini" @click="clear(false)">清空</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        :row-key="
          (row) => {
            return row.dataId;
          }
        "
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column label="升级前产品编码" prop="productCodeBefore" width="130"> </el-table-column>
        <el-table-column label="升级前产品名称" prop="productNameBefore"> </el-table-column>
        <el-table-column label="上市时间" prop="upDateBefore" width="130"> </el-table-column>
        <el-table-column label="升级后产品编码" prop="productCode" width="130"> </el-table-column>
        <el-table-column label="升级后产品名称" prop="productName"> </el-table-column>
        <el-table-column label="上市时间" prop="upDate" width="130"> </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="synchronous(scope.row)">同步</el-button>
            <el-button type="text" @click="clear(scope.row)" style="color: red">清空</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from "@/utils/tableMixin";
import axios from "@/utils/axiosInstance";
import { downloadFile } from "@/utils";
import moment from "moment";
export default {
  name: "UpgradeEncoding",
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: "productUpdateInfo",
      columnData: [],
      loading: false,
      searchForm: {
        platName: "",
        storeName: "",
        billStatusDesc: "",
        sendStatus: "",
      },
      exportData: {},
      searchCollapse: false,
      selectionVal: [],
      queryCriteria: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  methods: {
    onSearch() {
      let productCodeBefore = this.searchForm.productCodeBefore && this.searchForm.productCodeBefore.split(" ").length > 1000;
      let productCode = this.searchForm.productCode && this.searchForm.productCode.split(" ").length > 1000;
      if (productCodeBefore || productCode) {
        this.$message.error("已超过1000条，请核对！");
        return;
      }
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "productCodeBefore", //平台单号
          val: this.searchForm.productCodeBefore ? this.searchForm.productCodeBefore.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "productNameBefore", //sku名称
          val: this.searchForm.productNameBefore ? this.searchForm.productNameBefore : "",
          op: "like",
        },
        {
          attributeName: "productCode", //平台单号
          val: this.searchForm.productCode ? this.searchForm.productCode.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "productName", //sku名称
          val: this.searchForm.productName ? this.searchForm.productName : "",
          op: "like",
        },
        ,
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            if (!type) {
              this.tableReload = false;
              this.$nextTick((_) => {
                this.tableReload = true;
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    handleSelectionChange(val) {
      this.selectionVal = val;
    },

    reset() {
      if (this.$refs["table"]) {
        this.$refs["table"].clearSort(); //切换清除排序
      }
      // this.filterPropertyName = [];
      this.searchForm = {
        platName: "",
        storeName: "",
        billStatusDesc: "",
        sendStatus: "",
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    async synchronous(row) {
      let selectionType = !row && !this.selectionVal.length;
      if (selectionType) {
        this.$message.error("请选择后在进行操作！");
        return;
      }
      let status = await this.$confirm("是否确认同步？", "提示", {
        type: "warning",
      });
      if (status !== "confirm") return;
      let data = {
        dataIdList: !row ? this.selectionVal.map((v) => v.dataId) : [row.dataId],
      };
      let res = await this.$q.product.listingTimeSync({ data: data });
      if (res.success) {
        this.$message.success("同步成功");
      } else {
        this.$message.fail(res.message);
      }
      this.onSearch();
    },

    async clear(row) {
      let selectionType = !row && !this.selectionVal.length;
      if (selectionType) {
        this.$message.error("请选择后在进行操作！");
        return;
      }
      let status = await this.$confirm("是否确认清空？", "提示", {
        type: "warning",
      });
      if (status !== "confirm") return;
      let data = {
        dataIdList: !row ? this.selectionVal.map((v) => v.dataId) : [row.dataId],
      };
      let res = await this.$q.product.listingTimeCleanUp({ data: data });
      if (res.success) {
        this.$message.success("清空成功");
      } else {
        this.$message.fail(res.message);
      }
      this.onSearch();
    },
     // 导出
    exportExcel() {
      console.log(this.searchFormData)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData
        },
        reportName: this.reportName
      }
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！')
          loading.close()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
// >>> .el-form-item {
//   margin-bottom: 10px;
// }
</style>
